export const SETTINGS = {
  NAME: 'InsertText',
};

export const COMMANDS = {
  insertText: 'mm-insertText',
} as const;
